import { acceptHMRUpdate, defineStore } from 'pinia';
import { skillPrimary, experienceSkill } from '@/types/pages/candidate/Skill';
const initialState: skillPrimary = {
  resume_skills: [],
  self_description: '',
  portfolio_url: '',
  candidate_resume_skills: [],
};

export const useSkillStore = defineStore('basicSkill.store', {
  state: (): skillPrimary => ({ ...initialState }),
  actions: {
    addForResumeSkill(id: number, name: string) {
      this.resume_skills.push({ id, name, years_of_experience: 0 });
      // if(this.resume_skills.find(skill => skill.id === id))
      //   return this.resume_skills = this.resume_skills.filter(skill => skill.id != id)
      // else this.resume_skills.push({ id, name })
    },

    updateYearForResumeSkill(id: number, year: number) {
      this.resume_skills.map(skill => {
        if (skill.id == id) skill.years_of_experience = year;
      });
    },
    setSkillExperience(candidate_resume_skills: experienceSkill[]) {
      this.candidate_resume_skills = candidate_resume_skills.map(skill => ({
        id: skill.id,
        skill_id: skill.skill_id,
        name: skill.name,
        years_of_experience: skill.years_of_experience,
      }));
    },

    addSkillExperience(skill_id: number, name: string) {
      if (this.candidate_resume_skills.find(skill => skill.skill_id === skill_id)) {
      }
      // return this.candidate_resume_skills = this.candidate_resume_skills.filter(skill => skill.skill_id != skill_id)
      else
        this.candidate_resume_skills.push({
          id: undefined,
          name,
          skill_id: skill_id,
          years_of_experience: 0,
        });
    },

    updateYearSkillExperience(skill_id: number, year: number, name: string) {
      let isExist = false;
      this.candidate_resume_skills.map(skill => {
        if (skill.skill_id == skill_id) {
          isExist = true;
          skill.years_of_experience = year;
        }
      });
      if (!isExist)
        this.candidate_resume_skills.push({
          id: undefined,
          name,
          skill_id: skill_id,
          years_of_experience: year,
        });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSkillStore, import.meta.hot));
}
